import React from "react";
export default function BannerView(props) {
    return (
        <header className="header">
            <div className="container header-banner" id="banner">
                <div className="row">
                    <div className="col-12">
                        <div className="logo d-flex">
                            <a href="/">
                                {/* <img
                                    style={{height: '60px'}}
                                    className="logo"
                                    src={require("../../assets/image/logo.png")}
                                    alt="Logo"
                                /> */}
                                <div style={{
                                    border: "solid 2.5px",
                                    padding: "10px 15px",
                                    width: "fit-content",
                                    color: "white",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                }}>
                                    AV0129
                                </div>
                            </a>
                            <div className="header-title text-uppercase">
                                <div className="title1">Ý tưởng quy hoạch công viên văn hóa đa chức năng</div>
                                <div>khu vực bãi nổi giữa và bãi ven sông Hồng</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
